






























































































import Vue from "vue";
import moment from "moment";
import { RootState } from "@/store";
import { mapGetters, mapState } from "vuex";

import { formatBytes } from "@/utility/Formatter";

export default Vue.extend({
    props: {
        loading: Boolean,
        metricsTotals: {},
    },
    computed: {
        ...mapGetters(["userDateFormat"]),
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        dateList() {
            let dateListString = [];
            if (this.metricsTotals.daysList && this.metricsTotals.daysList.length > 0)
                this.metricsTotals.daysList.forEach((m) => {
                    dateListString.push(moment(m).format(this.userDateFormat));
                });
            return dateListString;
        },
        networkInSeries() {
            if (this.metricsTotals && this.metricsTotals.dailyTotalByteReceived && this.metricsTotals.dailyTotalByteReceived.length > 0)
                return [{ name: this.$t("network_metrics.serverIn"), data: this.metricsTotals.dailyTotalByteReceived }];
            return [];
        },
        networkOutSeries() {
            if (this.metricsTotals && this.metricsTotals.dailyTotalByteSent && this.metricsTotals.dailyTotalByteSent.length > 0)
                return [{ name: this.$t("network_metrics.serverOut"), data: this.metricsTotals.dailyTotalByteSent }];
            return [];
        },
        averageNetworkIn() {
            if (this.metricsTotals && this.metricsTotals.dailyTotalByteReceived && this.metricsTotals.dailyTotalByteReceived.length > 0)
                return Math.round(this.metricsTotals.dailyTotalByteReceived.reduce((acc, x) => acc + x) / this.metricsTotals.dailyTotalByteReceived.length);
            return 0;
        },
        averageNetworkOut() {
            if (this.metricsTotals && this.metricsTotals.dailyTotalByteSent && this.metricsTotals.dailyTotalByteSent.length > 0)
                return Math.round(this.metricsTotals.dailyTotalByteSent.reduce((acc, x) => acc + x) / this.metricsTotals.dailyTotalByteSent.length);
            return 0;
        },
        chartNetworkInTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "line",
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    title: {
                        text: this.$t("network_metrics.networkInTrendTotal__title"),
                        align: "center",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateList,
                        tickAmount: 4,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value: number) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value: number) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                },
                series: this.networkInSeries,
            };
        },
        chartNetworkOutTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "line",
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    title: {
                        text: this.$t("network_metrics.networkOutTrendTotal__title"),
                        align: "center",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateList,
                        tickAmount: 4,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 2) : null),
                        },
                    },
                },
                series: this.networkOutSeries,
            };
        },
    },
    methods: { formatBytes },
});
